import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  confirmCandidate,
  dismissCandidate,
  evaluatePlays,
  getPlayCandidates,
  getPlaysOverview,
  type CandidateStatus,
  type PlayId,
} from '../api/plays';

export function usePlaysOverview() {
  return useQuery({
    queryKey: ['gtm-plays', 'overview'],
    queryFn: getPlaysOverview,
  });
}

export function usePlayCandidates(params: { playId?: PlayId; statuses?: CandidateStatus[] }) {
  return useQuery({
    queryKey: ['gtm-plays', 'candidates', params],
    queryFn: () => getPlayCandidates(params),
  });
}

/** Re-read every detector. Reads the leads sheet; enrols nobody. */
export function useEvaluatePlays() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (options: { apollo?: boolean } = {}) => evaluatePlays(options),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['gtm-plays'] });
    },
  });
}

/** The click that enrols. The result says enrolled or blocked, with the reason. */
export function useConfirmCandidate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => confirmCandidate(id),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: ['gtm-plays'] });
    },
  });
}

export function useDismissCandidate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, note }: { id: string; note?: string }) => dismissCandidate(id, note),
    onSettled: () => {
      void qc.invalidateQueries({ queryKey: ['gtm-plays'] });
    },
  });
}
